import { Desensitization } from "@dg/utils"
import { Field } from "vant"
import { computed, defineComponent, ref } from "vue"
import styles from "./index.module.less"
import { certDesensitization } from "@/utils/basic"

const funcs = {
  cnName: Desensitization["cnName"],
  idCard: certDesensitization,
  phone: Desensitization["phone"]["phone"]
}
export default defineComponent({
  name: "DesensitizationInput",
  props: {
    modelValue: { type: [String, Number], default: "" },
    readonly: Boolean,
    disabled: Boolean,
    placeholder: String,
    config: Object,
    type: { type: [String, Function], default: "" }
  },
  emits: ["update:modelValue"],
  setup(props, { slots, emit, expose }) {
    const show = ref(false)

    const desensitization = computed(() => {
      const { [props.type]: func } = funcs
      if (func) return func
      else return (v) => v
    })

    const insideValue = computed({
      get() {
        if (show.value) {
          return props.modelValue
        } else {
          if (props.modelValue) {
            const name = desensitization.value(props.modelValue)
            const { target } = name
            return target
          } else {
            return props.modelValue
          }
        }
      },
      set(newValue) {
        emit("update:modelValue", newValue)
      }
    })

    const inputProps = computed(() => {
      return {
        readonly: props.readonly,
        disabled: props.disabled,
        placeholder: props.placeholder,
        class: styles.input,
        onFocus: () => {
          show.value = true
        },
        onBlur: () => {
          show.value = false
        },
        ...props.config
      }
    })

    const inputRef = ref(null)
    expose({
      inst: inputRef
    })

    return () => (
      <Field
        ref={inputRef}
        vModel={insideValue.value}
        vSlots={slots}
        {...inputProps.value}
      />
    )
  }
})
